module.exports = __webpack_public_path__ + "img/home-2-INTphonepeople.84472ac5.png";